import { OpportunityScore } from '../types/opportunity';

export const normalizeScores = (opportunities: OpportunityScore[] | undefined) => {
  if (!opportunities || opportunities.length === 0) {
    return [];
  }
  
  console.log('Input scores (AFTER our geometric mean calculation):', opportunities.map(opp => ({
    name: opp.Name,
    value: opp.valueScore.toFixed(3),
    feasibility: opp.feasibilityScore.toFixed(3),
    final: opp.finalScore.toFixed(3)
  })));

  // Simple conversion from 0-1 range to 0-100 range
  // DO NOT apply any center-of-gravity or min-max normalization that would break our geometric mean
  return opportunities.map(opp => {
    const normalizedOpp = {
      ...opp,
      valueScore: opp.valueScore * 100,
      feasibilityScore: opp.feasibilityScore * 100,
      finalScore: opp.finalScore * 100
    };
    
    console.log(`Normalized ${opp.Name}:`, {
      'value%': normalizedOpp.valueScore.toFixed(1),
      'feasibility%': normalizedOpp.feasibilityScore.toFixed(1),
      'final%': normalizedOpp.finalScore.toFixed(1)
    });
    
    return normalizedOpp;
  });
};